import { useState, useEffect } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Header.css';
import {
    Row,
    Col,
    Nav,
    Dropdown
} from 'react-bootstrap';
import NavDropdown from '../NavDropdown';
import LanguagesSelector from '../LanguagesSelector';
import Translator from '../../translates/Translator';

const Header = ({ lang, changeLanguage }) => {
    const t = Translator();
    const currentPath = useLocation().pathname;

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [showHomeBtn, setShowHomeBtn] = useState(window.innerWidth > 1150);
    const resize = () => {
        (window.innerWidth < 768) ? setIsMobile(true) : setIsMobile(false);
        (window.innerWidth > 1200) ? setShowHomeBtn(true) : setShowHomeBtn(false);
    }
    useEffect(() => { window.addEventListener("resize", resize); }, []);

    const navLink = (href, label, extraClass = "") => (
        <Nav.Link
            href={href}
            className={`px-lg-4 ${extraClass} ${currentPath === href ? "active-link" : ""}`}
        >
            {t(label)}
        </Nav.Link>
    );

    const headerBody = () => {
        return isMobile ? (
            <div className=''>
                <Nav.Link href="/" className=''>
                    <img
                        id='headerLogo'
                        alt=""
                        src="/logo.png"
                        height="50"
                        className="ikaLogoSmall"
                    />
                </Nav.Link>
                <h2 className='header-title text-lightest m-0 text-center align-content-center'>IKA&nbsp;DATA</h2>
                <LanguagesSelector lang={lang} changeLanguage={changeLanguage} />
                <Dropdown className='menu'>
                    <Dropdown.Toggle variant="primary">
                        &equiv;
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='fade'>
                        <Dropdown.Item href="/">{t("Homepage")}</Dropdown.Item>
                        <Dropdown.ItemText>{t("header-services")}:</Dropdown.ItemText>
                        <Dropdown.Item href="/services/archibus" className='sub-item'>{t("Archibus")}</Dropdown.Item>
                        <Dropdown.Item href="/services/bim" className='sub-item'>{t("BIM")}</Dropdown.Item>
                        <Dropdown.Item href="/about-us">{t("About-us")}</Dropdown.Item>
                        <Dropdown.Item href="/contact">{t("Contact")}</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        ) : (
            <Row>
                <Col md={4} className='ps-0'>
                    <Nav.Link href="/" className='d-flex'>
                        <img
                            id='headerLogo'
                            alt=""
                            src="/logo.png"
                            className="ikaLogo"
                        />
                        <h2 className='header-title text-lightest m-0 px-3 align-content-center'>
                            IKA&nbsp;DATA
                        </h2>
                    </Nav.Link>
                </Col>
                <Col className='d-flex justify-content-end'>
                    <Nav className="h-100">
                        {showHomeBtn ? navLink("/", "Homepage") : <span></span>}
                        <NavDropdown label={t("header-services")}>
                            {navLink("/services/archibus", "Archibus", "dropdown-item")}
                            {navLink("/services/bim", "BIM", "dropdown-item")}
                        </NavDropdown>
                        {navLink("/about-us", "About-us")}
                        {navLink("/contact", "Contact")}
                    </Nav>
                    <LanguagesSelector lang={lang} changeLanguage={changeLanguage} />
                </Col>
            </Row>
        );
    }

    return (
        <header className="header gray-dark-bg text-white" id='header'>
            {headerBody()}
        </header>
    );
};

export default Header;
